import React from "react";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";

export default function Login() {
  const startLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/prenotazioni";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <Layout>
      <section className="max-w-[600px] mx-auto px-6 lg:px-10 py-24 text-center">
        <div className="overline">Area Riservata</div>
        <h1 className="font-display text-5xl mt-3">Accesso Amministratore</h1>
        <p className="mt-4 text-[#6B6960]">Accedi con il tuo account Google per gestire le prenotazioni.</p>
        <div className="mt-8">
          <Button onClick={startLogin} data-testid="google-login-btn" className="btn-primary-cdm rounded-full h-12 px-8">
            Accedi con Google
          </Button>
        </div>
      </section>
    </Layout>
  );
}
